import { initializeApp } from "firebase/app";
import {getFirestore, enableIndexedDbPersistence, initializeFirestore, CACHE_SIZE_UNLIMITED} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getAuth, GoogleAuthProvider, FacebookAuthProvider, GithubAuthProvider} from "firebase/auth"
import {getFunctions} from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAnGYqUM_wOYmpm8BXrlMnWTDd1SV-4F2E",
  authDomain: "cryptoverse-921ab.firebaseapp.com",
  projectId: "cryptoverse-921ab",
  storageBucket: "cryptoverse-921ab.appspot.com",
  messagingSenderId: "367412304221",
  appId: "1:367412304221:web:217b574f75e1f714cff0b4",
  measurementId: "G-RYVBK2F0CS"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const githubProvider = new GithubAuthProvider();


// export const db = getFirestore(app);
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
});
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code === "unimplemented") {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
    alert("Browser not supported");
  }
});


